import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FuseSplashScreenService {
  public player: Animation;
  public splashScreenEl: HTMLElement | null;

  /**
   * Constructor
   *
   * @param _document
   * @param {Router} _router
   */
  public constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _router: Router,
  ) {
    // Initialize
    this._init();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Hide the splash screen
   */
  public hide(): void {
    // Fade the splash screen out via the Web Animations API (replaces the former AnimationBuilder player).
    this.player = this.splashScreenEl!.animate([{ opacity: 1 }, { opacity: 0, zIndex: -10 }], {
      duration: 400,
      easing: 'ease',
      fill: 'forwards',
    });

    setTimeout(() => {
      this.splashScreenEl!.style.display = 'none';
    }, 500);
  }

  /**
   * Show the splash screen
   */
  public show(): void {
    // Fade the splash screen in via the Web Animations API (replaces the former AnimationBuilder player).
    this.player = this.splashScreenEl!.animate([{ opacity: 0, zIndex: 99999 }, { opacity: 1 }], {
      duration: 400,
      easing: 'ease',
      fill: 'forwards',
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    // Get the splash screen element
    this.splashScreenEl = this._document.body.querySelector('#fuse-splash-screen');

    // If the splash screen element exists...
    if (this.splashScreenEl) {
      // Hide it on the first NavigationEnd event
      this._router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => {
          setTimeout(() => {
            this.hide();
          });
        });
    }
  }
}
